module.exports = __webpack_public_path__ + "static/media/truck-icon.c544fd6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/truck-icon.png
// module id = 273
// module chunks = 0